<script>
	import { page } from '$app/stores'
	import { INSTALLATION_CATEGORY } from '$lib/consts'
	import { ArticleV4, OtherArticlesV4 } from '$lib/modules/blog'
	import { DOCUMENTS, PRIVACY_POLICY } from '$lib/routes'
	import { t } from '$lib/translations'
	import { HeaderForm, FAQ } from '$lib/ui-woltair/components'
	import { Button, Field, Form, v } from '$lib/ui-woltair/form'
	import { returnPathName } from '$lib/utils'
	import { PUBLIC_WOLTAIR_WEB_CODE } from '$env/static/public'

	export let data

	const formProps = {
		initialValues: {
			phone: '',
			installationProductCategory: INSTALLATION_CATEGORY.TEPELNE_CERPADLO,
			leadSource: 'FINANCING_HVAC'
		},
		validationSchema: {
			phone: '',
			...(PUBLIC_WOLTAIR_WEB_CODE === 'WOLTAIR_PL' && {
				marketingConsentEmail: v
					.bool()
					.oneOf([true], t('web.woltadvisor.conditions.validate'))
					.required(t('web.woltadvisor.conditions.validate')),
				marketingConsentPhone: v
					.bool()
					.oneOf([true], t('web.woltadvisor.conditions.validate'))
					.required(t('web.woltadvisor.conditions.validate')),
				marketingConsentPost: v
					.bool()
					.oneOf([true], t('web.woltadvisor.conditions.validate'))
					.required(t('web.woltadvisor.conditions.validate')),
				marketingConsentGeneral: v
					.bool()
					.oneOf([true], t('web.woltadvisor.conditions.validate'))
					.required(t('web.woltadvisor.conditions.validate'))
			})
		}
	}

	const header = {
		heading: t('web.heat_pump.financing.heading'),
		subheading: t('web.heat_pump.financing.subheading')
	}
</script>

<HeaderForm {header}>
	<Form {...formProps} buttonLoader actionURL={`${returnPathName($page.url.pathname)}/action`}>
		<Field name="phone">{t('web.forms.yourPhone')}</Field>
		{#if PUBLIC_WOLTAIR_WEB_CODE === 'WOLTAIR_PL'}
			<Field
				name="heading"
				type="plainText"
				maxWidth="500px"
				label="Wyrażam zgodę na przetwarzanie moich danych osobowych przez Woltair.pl sp. z o.o. dla celów zindywidualizowanego marketingu bezpośredniego i przekazywanie mi informacji handlowych przy użyciu telekomunikacyjnych urządzeń końcowych i automatycznych systemów wywołujących, w tym poprzez:"
			/>
			<Field name="marketingConsentEmail" type="checkbox" maxWidth="500px" label="Email" />
			<Field
				name="marketingConsentPhone"
				type="checkbox"
				maxWidth="500px"
				label="Telefon (tj. połączenia telefoniczne lub/i SMS lub/i MMS)"
			/>
			<Field
				name="marketingConsentPost"
				type="checkbox"
				maxWidth="500px"
				label="Pocztę tradycyjną"
			/>
			<Field
				name="marketingConsentGeneral"
				type="checkbox"
				maxWidth="500px"
				label={`<span>Przesyłając formularz wyrażam zgodę na przetwarzanie moich danych osobowych przez Woltair.pl Sp. z o.o., <a target="_blank" class="text-primary-500" href="/documents/informacja-o-przetwarzaniu-danych-osobowych.pdf">zgodnie z niniejszymi zasadami</a>.</span>`}
			/>
		{/if}
		<p class="inset-x-0 mx-auto max-w-96">
			{@html t('web.forms.conditions', {
				class: 'text-primary-500',
				link: `/${DOCUMENTS}/${PRIVACY_POLICY}`
			})}
		</p>
		<Button type="submit">{t('web.forms.getMoreInfo')}</Button>
		<svelte:fragment slot="success">{t('web.forms.questionWasSent')}</svelte:fragment>
	</Form>
</HeaderForm>
{#if data.article}
	<section class="page-wrapper">
		<ArticleV4 article={data.article} />
	</section>
{/if}
{#if data.faqs}
	<section class="page-wrapper relative mt-24">
		<FAQ faqs={data.faqs} />
	</section>
{/if}
{#if data.otherArticles}
	<section class="page-wrapper">
		<OtherArticlesV4 otherArticles={data.otherArticles} />
	</section>
{/if}
